import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, UncontrolledDropdown } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getContentBlockItemsByName, getContentBlockMixedItems, getContentBlockMixedItem } from '../../../Cms/CmsActions.js';

import CmsBlockItem from '../../../Cms/components/content/CmsBlockItem.js';
import { capitalizeFirstLetter } from '../../../../util/text.js';
import HtmlComponent from '../../../../components/Text/HtmlComponent.js';

function PanelMainMenu({ intl, panel, user = null, isMobile = false, closeMenu = null }) {
    const [isOpen, toggle] = useState(false);
    const menuItems = getContentBlockItemsByName(panel.blocks, 'links');

	const formatLinkItem = (item, itemName = 'mainLevel') => getContentBlockMixedItem(item, itemName) && ({
		to: getContentBlockMixedItem(item, itemName).path,
		name: getContentBlockMixedItem(item, itemName).text,
		isExternal: /http(s)?:\/\//.test(getContentBlockMixedItem(item, itemName)?.path),
		children: (getContentBlockMixedItems(item, 'subLevel') || []).map(subLevel => ({
			to: subLevel.path,
			name: subLevel.text,
			isExternal: /http(s)?:\/\//.test(subLevel.path),
		})),
	});

    const isRouteAllowed = route => {
        return (
            !route.allowedRoles
            || (user?.role && route.allowedRoles.includes(user.role))
        );
    };

	const getRoutes = () => {
        return menuItems.map(menuItem => formatLinkItem(menuItem))
		.concat([
            {
                name: 'console',
                allowedRoles: ['admin', 'manager', 'printer'],
                children: [
                    {
                        to: '/console/conversations',
                        name: 'conversations',
                        picto: 'comments',
                        allowedRoles: ['admin', 'manager', 'printer'],
                    },
                    {
                        to: '/console/orders/onpreparation',
                        name: 'orders',
                        picto: 'list',
                        allowedRoles: ['admin', 'manager'],
                    },
                    {
                        to: '/console/users',
                        name: 'users',
                        picto: 'users',
                        allowedRoles: ['admin', 'manager'],
                    },
                    {
                        to: '/console/products',
                        name: 'products',
                        picto: 'cubes',
                        allowedRoles: ['admin'],
                    },
                    {
                        to: '/console/vouchers',
                        name: 'vouchers',
                        picto: 'tags',
                        allowedRoles: ['admin', 'manager'],
                    },
                    {
                        to: '/console/shippings',
                        name: 'shippings',
                        picto: 'truck',
                        allowedRoles: ['admin'],
                    },
                    {
                        to: '/console/contents',
                        name: 'cms',
                        picto: 'pen',
                        allowedRoles: ['admin'],
                    },
                    {
                        to: '/console/config',
                        name: 'configuration',
                        picto: 'cogs',
                        allowedRoles: ['admin'],
                    },
                ],
            },
            // {
            //     type: 'title',
            //     name: 'administrationTitle',
            //     allowedRoles: ['admin'],
            // },
        ])
		.filter(route => route && isRouteAllowed(route));
    };

	const renderRoutes = (routes, level = 0) => {
        return routes
            .map((route, index) => {
                if(route.type === 'divider') {
                    return <NavItem key={index} className="p-2 sidebar-divider text-dark">|</NavItem>;
                }
                if(route.type === 'title') {
                    return (
                        <NavItem key={index} className="d-block sidebar-heading">
                            <span className="p-2" style={{ position: 'absolute', top: '0' }}><FormattedMessage id={route.name} defaultMessage={capitalizeFirstLetter(route.name)} /></span>
                        </NavItem>
                    );
                }
                if((route.children || []).length) {
                    return (
                        <UncontrolledDropdown key={index} nav inNavbar>
                            <DropdownToggle nav caret>
                                <span className="menuText p-1 pt-3"><FormattedMessage id={route.name} defaultMessage={capitalizeFirstLetter(route.name)} /></span>
                            </DropdownToggle>
                            <DropdownMenu className="general-submenu">
                                {renderRoutes(route.children, level + 1)}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    );
                }
				const textLink = <HtmlComponent
					inline
					text={intl.formatMessage({
						id: route.name,
						defaultMessage: capitalizeFirstLetter(route.name),
					}).replace(/\s/, '<br />')}
				/>;
                const navLink = route.isExternal
                    ? (
                        <a href={route.to} target="_blank" className="nav-link" rel="noreferrer">
                            {route.picto && <span className="icon"><FontAwesome name={route.picto} size="lg" /></span>} <span className="menuText p-1">{textLink}</span>
                        </a>
                    ) : (
                        <Link to={route.to} onClick={route.onClick || (() => {})} className="nav-link">
                            {route.picto && <span className="icon"><FontAwesome name={route.picto} size="lg" /></span>} <span className="menuText p-1">{textLink}</span>
                        </Link>
                    );
                return (
                    level ? <DropdownItem key={index}>{navLink}</DropdownItem> : <NavItem key={index} tag={level ? 'span' : 'li'}>{navLink}</NavItem>
                );
            }).filter(route => route);
    };

    if(user && menuItems?.length) {
		const routes = getRoutes();
		return routes.length > 0 && (
			<Nav id="accordionSidebar">
				{renderRoutes(routes)}
			</Nav>
		);

        // return (
        //     <div className={classnames('main-menu', 'position-relative', isMobile && ['mt-4', 'mobile'], isOpen && 'open')}>
        //         {links.filter(link => getContentBlockMixedItem(link, 'mainLevel') && getContentBlockMixedItem(link, 'mainLevel').path).map((link, index) => (
        //             getContentBlockMixedItems(link, 'subLevel') && getContentBlockMixedItems(link, 'subLevel').length
        //             ? (
        //                 <Fragment key={index}>
        //                     <strong className="d-flex justify-content-between ms-2 text-uppercase text-lg text-danger" onClick={closeMenu}>
        //                         {getContentBlockMixedItem(link, 'mainLevel').text}
        //                         {closeMenu && <FontAwesome name="close" size="4x" className="active" />}
        //                     </strong>
        //                     <ul className="ms-3 list-unstyled">
        //                         {getContentBlockMixedItems(link, 'subLevel').map(sub => (
        //                             <li key={sub.path}><Link to={sub.path} onClick={closeMenu}>{sub.text}</Link></li>
        //                         ))}
        //                     </ul>
        //                 </Fragment>
        //             )
        //             : <CmsBlockItem key={index} item={getContentBlockMixedItem(link, 'mainLevel')} type="link" />
        //         ))}
        //     </div>
        // );
    }
    return null;
}
// <Nav>
//     {links.filter(link => getContentBlockMixedItem(link, 'mainLevel') && getContentBlockMixedItem(link, 'mainLevel').path).map((link, index) => (
//         <li key={index}>
//             {
//                 getContentBlockMixedItems(link, 'subLevel') && getContentBlockMixedItems(link, 'subLevel').length
//                 ? (
//                     <UncontrolledDropdown>
//                         <DropdownToggle caret tag={Link} to="#" onClick={event => event.preventDefault()} className={classnames(isOpen && ['border-bottom-warning', 'open'])}>
//                             {getContentBlockMixedItem(link, 'mainLevel').text}
//                         </DropdownToggle>
//                         <DropdownMenu className="general-submenu">
//                             {getContentBlockMixedItems(link, 'subLevel').map(sub => <DropdownItem key={sub.path} tag={Link} to={sub.path} className="text-dark">{sub.text}</DropdownItem>)}
//                         </DropdownMenu>
//                     </UncontrolledDropdown>
//                 )
//                 : <NavItem><CmsBlockItem item={getContentBlockMixedItem(link, 'mainLevel')} type="link" /></NavItem>
//             }
//         </li>
//     ))}
// </Nav>

//      <!-- This checkbox will give us the toggle behavior, it will be hidden, but functional -->
//     <input id="toggle" type="checkbox">
//
//     <!-- IMPORTANT: Any element that we want to modify when the checkbox state changes go here, being "sibling" of the checkbox element -->
//
//     <!-- This label is tied to the checkbox, and it will contain the toggle "buttons" -->
//     <label class="toggle-container" for="toggle">
//         <!-- If menu is open, it will be the "X" icon, otherwise just a clickable area behind the hamburger menu icon -->
//         <span class="button button-toggle"></span>
//     </label>
//
//     <!-- The nav menu -->
//     <nav class="nav">
//         <a class="nav-item" href="">Dashboard</a>
//         <a class="nav-item" href="">History</a>
//         <a class="nav-item" href="">Statistics</a>
//         <a class="nav-item" href="">Settings</a>
//     </nav>
//

function mapStateToProps(store) {
    return {
        user: store.users.user,
    };
}

PanelMainMenu.propTypes = {
	intl: PropTypes.object.isRequired,
	user: PropTypes.object,
    panel: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    closeMenu: PropTypes.func,
};

export default connect(mapStateToProps)(injectIntl(PanelMainMenu));
